import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import app from "./app.module";
import { account } from "./account.module";
import { menus } from "./menus.module";
import attachments from "@/store/attachments.module";

// import filter from "./filter.module";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      key: "doa-digitalsignature",
      paths: ["account"],
      // storage: window.sessionStorage
      // storage: {
      //   getItem: key => ls.get(key),
      //   setItem: (key, value) => ls.set(key, value),
      //   removeItem: key => ls.remove(key)
      // }
    }),
  ],
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    account,
    app,
    menus,
    attachments
    //filter
  },
});
